/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    favoriteLocationAdd,
    favoriteLocationDelete,
    favoriteLocationList,
    locationDetails,
    locationImageList,
    locationList,
    locationAllList,
    locationInactiveList,
    seoLocationList,
} from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getAppHeaders, getBuyerHeaders, getBuyersUrl, getSellerReadOnlyUrl, getSellerUrl } from 'shared/http';


class LocationService {
    constructor() {
        this.service = interfaceService.getService();
    }

    getLocationList(data) {
        return this.service.post(getSellerReadOnlyUrl(locationList), JSON.stringify(data), getAppHeaders());
    }

    getAllLocationList(data) {
        return this.service.post(getSellerReadOnlyUrl(locationAllList), JSON.stringify(data), getAppHeaders());
    }
    getInactiveLocationList(data) {
        return this.service.post(getSellerReadOnlyUrl(locationInactiveList), JSON.stringify(data), getAppHeaders());
    }

    getLocationDetails(locationId, data = {}) {
        return this.service.post(getSellerReadOnlyUrl(`${locationDetails}${locationId}`), JSON.stringify(data), getAppHeaders());
    }

    getLocationImagesList(data) {
        return this.service.post(getSellerReadOnlyUrl(locationImageList), JSON.stringify(data), getAppHeaders());
    }

    getFavoriteLocation(data) {
        return this.service.post(getBuyersUrl(favoriteLocationList), JSON.stringify(data), getBuyerHeaders());
    }

    addFavoriteLocation(data) {
        return this.service.post(getBuyersUrl(favoriteLocationAdd), JSON.stringify(data), getBuyerHeaders());
    }

    deleteFavoriteLocation(data) {
        return this.service.delete(getBuyersUrl(favoriteLocationDelete), getBuyerHeaders(true, 'json', data));
    }

    SEOLocationList(data) {
        return this.service.post(getBuyersUrl(`${seoLocationList}`), JSON.stringify(data), getBuyerHeaders());
    }
}

export default new LocationService();